import StepRoute from '../classes/step-route.class';
import RouteNames from '../constants/route-names';

const route = new StepRoute(
  RouteNames.CompanyNotFound,
  '/company-not-found',
  () => import('@/views/CompanyNotFound.vue'),
);

export default route.getRoute();
